import React from 'react';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';

function DraggableModal(props) {
	return (
		<Draggable
			handle=".MuiDialogTitle-root"
			cancel=".MuiDialogActions-root, .MuiDialogActions-root *, .MuiDialogContent-root, .MuiDialogContent-root *, button, a, input, textarea, select"
		>
			<Paper {...props} />
		</Draggable>
	);
}

export default DraggableModal;
